import { render, staticRenderFns } from "./QuickbooksLogo.vue?vue&type=template&id=68c96ed6&"
import script from "./QuickbooksLogo.vue?vue&type=script&lang=js&"
export * from "./QuickbooksLogo.vue?vue&type=script&lang=js&"
import style0 from "./QuickbooksLogo.vue?vue&type=style&index=0&id=68c96ed6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports